import { render, staticRenderFns } from "./singleGrades.vue?vue&type=template&id=7ba98288&scoped=true&"
import script from "./singleGrades.vue?vue&type=script&lang=js&"
export * from "./singleGrades.vue?vue&type=script&lang=js&"
import style0 from "./singleGrades.vue?vue&type=style&index=0&id=7ba98288&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba98288",
  null
  
)

export default component.exports